import { useEffect, useState } from "react";
import {
  getQuestionData,
  submitAnswerDataFe } from
"../../services/epic/bloodDonation";
import QuestionHeaders from "./QuestionHeaders";
import { Loader } from "../../common/Loader";
import { configureFirstIframe } from "../../utils/util";

const QuestionStep4 = ({
  setRequestStep,
  submittedAnswerDataRequest,
  setSubmittedAnswerDataRequest,
  requestStep,
  loading,
  setLoading,
  submittedAnswerData,
  setSubmittedAnswerData,
  handleCancel,
  translationMap
}) => {
  const [generalQuestion, setGeneralQuestion] = useState([]);
  const [isAllAnswered, setIsAllAnswered] = useState(false);
  const [sortedSections, setSortedSections] = useState([]);

  useEffect(() => {
    const questionRequestBody = { categoryIndex: 3 };
    getQuestionData(questionRequestBody).then((result) => {
      //console.log("questions in step 4", result?.data);
      setGeneralQuestion(result.data);
    });
    setLoading(false);
    configureFirstIframe(400, 750);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const groupedQuestions = generalQuestion.reduce((acc, question) => {
      if (!acc[question.sectionIndex]) {
        acc[question.sectionIndex] = {
          title: question.categoryTitle,
          key: question.categoryKey,
          questions: []
        };
      }
      acc[question.sectionIndex].questions.push(question);
      return acc;
    }, {});

    const sortedSections = Object.entries(groupedQuestions)
    .sort(([a], [b]) => a - b)
    .map(([_, value]) => value);
    //console.log("Sorted Sections", sortedSections);
    setSortedSections(sortedSections);
  }, [generalQuestion]);

  useEffect(() => {
    checkAllAnswered();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submittedAnswerData, sortedSections]);

  const checkAllAnswered = () => {
    if (!sortedSections || sortedSections.length === 0 || !submittedAnswerData) {
      return;
    }
    let allAnswered = true;

    for (const section of sortedSections) {
      const sectionKey = section.key;
      const sectionQuestions = section.questions || [];
      const sectionAnswers = submittedAnswerData[sectionKey] || [];
      if (sectionQuestions.length === 0) {
        continue;
      }
      const sectionFullyAnswered = sectionQuestions.every((question) => {
        const answer = sectionAnswers.find((item) => item.QUESTION_INDEX === question.questionIndex);
        return answer && answer.ANSWER !== "";
      });

      if (!sectionFullyAnswered) {
        allAnswered = false;
        break;
      }
    }
    // console.log("All Questions Answered:", allAnswered);
    setIsAllAnswered(allAnswered);
  };

  const handleChange = (
  e,
  stepKey,
  categoryIndex,
  questionIndex,
  categoryTitle,
  questionTitle) =>
  {
    const newAnswer = e.target.value;
    const currentStepData = submittedAnswerData[stepKey] || [];
    const questionExists = currentStepData.some(
      (item) => item.QUESTION_INDEX === questionIndex
    );
    const updatedStepData = questionExists ?
    currentStepData.map((item) =>
    item.QUESTION_INDEX === questionIndex ?
    { ...item, ANSWER: newAnswer } :
    item
    ) :
    [
    ...currentStepData,
    {
      CATEGORY_INDEX: categoryIndex,
      QUESTION_INDEX: questionIndex,
      CATEGORY_TITLE: categoryTitle,
      QUESTION_TITLE: questionTitle,
      ANSWER: newAnswer,
      GENDER: 0
    }];

    setSubmittedAnswerData({
      ...submittedAnswerData,
      [stepKey]: updatedStepData
    });
  };
  const submitAnswer = () => {
    const allAnswers = { ...submittedAnswerDataRequest };
    let newAnswerString = "";
    const currentSectionsToProcess = submittedAnswerData;
    Object.keys(currentSectionsToProcess).forEach((sectionKey) => {
      const sectionAnswers = currentSectionsToProcess[sectionKey];
      if (sectionAnswers?.length > 0) {
        allAnswers[sectionKey] = sectionAnswers;
        sectionAnswers.forEach((item) => {
          if (item?.ANSWER) {
            newAnswerString += item?.ANSWER;
          }
        });
      }
    });
    let updatedQrCodeValue = newAnswerString;
    const answerDataRequestBody = {
      ...allAnswers,
      qrCodeValue: updatedQrCodeValue
    };
    submitAnswerDataFe(answerDataRequestBody).then((result) => {
      if (result) {
        setRequestStep(6);
        window.parent.scrollTo(0, 0);
        setSubmittedAnswerDataRequest(answerDataRequestBody);
      }
    });
    setSubmittedAnswerDataRequest(answerDataRequestBody);
    setRequestStep(6);
  };

  if (loading) {
    return <Loader />;
  }
  return (
    <>
        <section
        className="w-100 clearfix BloodDonationMainSection"
        id="CoverPlanActive">
        
          <div className="container customContainer">
            <QuestionHeaders
            setRequestStep={setRequestStep}
            currentStep={requestStep - 1}
            translationMap={translationMap} />
          
            <div className="cover_inner_wrapper cover_inner_wrapper2">
              <div className="cover_main_box1">
                <div className="Optimized_Main_Wrap_Box Optimized_Main_Wrap_Box2">
                {sortedSections.map((section) =>
                <div className="optimized_welcome_box">
                    <div className="donation_form_title_box">
                      <p className="Gray_Title ">
                      {section.title}
                      </p>
                    </div>
                    {section.questions.map((questionData) =>
                  <div
                    className="General_Question_Box"
                    key={questionData.id}>
                    
                          <h6 className="question_txt">
                            {questionData?.questionIndex} -{" "}
                            {questionData?.questionTitle}
                          </h6>
                          <div className="article-question">
                            <div className="radio-inline">
                              <input
                          onClick={(e) =>
                          handleChange(
                            e,
                            questionData.categoryKey,
                            questionData.categoryIndex,
                            questionData.questionIndex,
                            questionData.categoryTitle,
                            questionData.questionTitle
                          )
                          }
                          className="radio-inline-input"
                          type="radio"
                          name={`${questionData?.questionIndex}`}
                          id={`Y_${questionData?.questionIndex}`}
                          value="Y"
                          checked={
                          submittedAnswerData?.[questionData.categoryKey]?.find(
                            (answer) => answer.QUESTION_INDEX === questionData?.questionIndex
                          )?.ANSWER === "Y"
                          } />
                        
                              <label
                          className="radio-inline-label"
                          htmlFor={`Y_${questionData?.questionIndex}`}>
                          
                                {translationMap?.yes}
                              </label>
                            </div>
                            <div className="radio-inline">
                              <input
                          onClick={(e) =>
                          handleChange(
                            e,
                            questionData.categoryKey,
                            questionData.categoryIndex,
                            questionData.questionIndex,
                            questionData.categoryTitle,
                            questionData.questionTitle
                          )
                          }
                          className="radio-inline-input"
                          type="radio"
                          name={`${questionData?.questionIndex}`}
                          id={`N_${questionData?.questionIndex}`}
                          value="N"
                          checked={
                          submittedAnswerData?.[questionData.categoryKey]?.find(
                            (answer) => answer.QUESTION_INDEX === questionData?.questionIndex
                          )?.ANSWER === "N"
                          } />
                        
                              <label
                          className="radio-inline-label"
                          htmlFor={`N_${questionData?.questionIndex}`}>
                          
                                {translationMap?.no}
                              </label>
                            </div>
                            {questionData.gender === 1 &&
                      <div className="radio-inline">
                                <input
                          onClick={(e) =>
                          handleChange(
                            e,
                            questionData.categoryKey,
                            questionData.categoryIndex,
                            questionData.questionIndex,
                            questionData.categoryTitle,
                            questionData.questionTitle
                          )
                          }
                          className="radio-inline-input"
                          type="radio"
                          name={`${questionData.questionIndex}`}
                          id={`M_${questionData.questionIndex}`}
                          value="M"
                          checked={
                          submittedAnswerData?.[questionData.categoryKey]?.find(
                            (answer) => answer.QUESTION_INDEX === questionData?.questionIndex
                          )?.ANSWER === "M"
                          } />
                        
                                <label
                          className="radio-inline-label"
                          htmlFor={`M_${questionData.questionIndex}`}>
                          
                                  {translationMap?.male || "Male"}
                                </label>
                              </div>
                      }
                          </div>
                        </div>
                  )}
                      </div>
                )}
                  <div className="optimized_btn_box optimized_btn_box_mrt">
                      <button
                    onClick={submitAnswer}
                    className={
                    !isAllAnswered ?
                    "disabled_btn_link" :
                    "bluetrans_btn_link"
                    }>
                    
                        {translationMap?.continue}
                      </button>
                      <button
                    onClick={() => {
                      setRequestStep(4);
                      window.parent.scrollTo(0, 0);
                    }}
                    className="bluetrans_btn_link">
                    
                        {translationMap?.back}
                      </button>
                      <button
                    onClick={handleCancel}
                    className="Orangetrans_btn_link">
                    
                        {translationMap?.cancel}
                      </button>
                  </div>
                </div>
              </div>
              <div className="cover_main_box2"></div>
            </div>
          </div>
        </section>
    </>);

};

export default QuestionStep4;